import React, { Component } from 'react';

//pages
import AreaRestrita from './../area-restrita/AreaRestrita';
import Login from './../login/Login';
import Erro404 from './../errors/Erro404';
import RecuperarSenha from './../recuperar/RecuperarSenha';
import PoliticaPrivacidade from './../politica/PoliticaPrivacidade';

//styles
import '../../styles/App.css';

// import route Components here
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  Redirect
} from 'react-router-dom';

class App extends Component {
  constructor (props){
    super(props);
    window.LANGUAGE = 'pt_BR';
  }

  componentDidMount() {

  }

  componentWillUnmount() {
  }

  render() {
    return (
      <Switch>
        <Route exact path="/" component={Login} />
        <Route exact path="/recuperar-senha/" component={RecuperarSenha} />
        <Route path="/area-restrita" component={AreaRestrita} />
        <Route path="/politica-privacidade" component={PoliticaPrivacidade} />
        <Route component={Erro404} />
      </Switch>
    );
  }
}


export default App;



// WEBPACK FOOTER //
// ./src/classes/app/App.js